// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CarouselStyle } from "@vanmeter/App/Components/XngCarousel";
import { ProductCarouselProductStyles } from "@vanmeter/Overrides/Components/ProductCarouselProduct";
import { css } from "styled-components";

interface SharedCarouselStyles {
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselProductStyles?: ProductCarouselProductStyles;
    carouselProductMiniCardStyles?: ProductCarouselProductStyles;
    xngCarouselStyles?: CarouselStyle;
    carouselProductCondensedStyles?: ProductCarouselProductStyles;
}

export const sharedCarouselStyles: SharedCarouselStyles = {
    carouselProductMiniCardStyles: {
        productGridContainerStyles: {
            container: {
                css: css`
                    &&& {
                        width: 328px !important;
                        grid-template-columns: 96px minmax(0, 1fr);
                        gap: 0px 8px;
                        height: 100%;
                    }
                `,
            },
            image: {
                css: css`
                    width: 100%;
                    height: 100%;
                    gap: 8px;
                    display: flex;
                    flex-direction: column;
                    &,
                    & [data-test-selector="productImage"] {
                        width: 96px;
                        height: 96px;
                        min-width: 96px;
                        max-width: 96px;
                        min-height: 96px;
                        max-height: unset;
                    }
                    grid-column: 1 / 2;
                    grid-row: 1 / 5;
                `,
            },
            title: {
                css: css`
                    grid-column: 2 / 3;
                    grid-row: 1 / 2;
                `,
            },
            description: {
                css: css`
                    grid-column: 2 / 3;
                    grid-row: 2 / 3;
                `,
            },
            partNumbers: {
                css: css`
                    grid-column: 2 / 3;
                    grid-row: 3 / 4;
                `,
            },
            availability: {
                css: css`
                    grid-column: 2 / 3;
                    grid-row: 4 / 5;
                    z-index: 2;
                `,
            },
            badges: {
                css: css`
                    grid-column: 2 / 3;
                    grid-row: 5 / 6;
                    z-index: 2;
                `,
            },
            price: {
                css: css`
                    grid-column: 1 / 3;
                    grid-row: 6 / 7;
                    z-index: 2;
                `,
            },
            addToCartActions: {
                css: css`
                    grid-column: 1 / 3;
                    grid-row: 7 / 8;
                `,
            },
            addToList: {
                css: css`
                    grid-column: 1 / 3;
                    grid-row: 8 / 9;
                `,
            },
        },
    },
    carouselProductCondensedStyles: {
        productGridContainerStyles: {
            container: {
                css: css`
                    &&& {
                        width: 204px !important;
                        min-width: unset;
                    }
                `,
            },
            image: {
                css: css`
                    min-width: 204px;
                    max-width: 204px;
                    min-height: 124px;
                    max-height: 124px;
                    height: 124px;
                    padding: 0;
                    margin-bottom: 8px;
                    ${StyledButton} {
                        min-width: 124px;
                        max-width: 124px;
                        min-height: 124px;
                        max-height: 124px;
                    }
                `,
            },
            addToCartActions: {
                css: css`
                    display: none;
                `,
            },
            addToList: {
                css: css`
                    display: none;
                `,
            },
        },
    },
};
